import clsx from 'clsx'
import { AnimatePresence, type HTMLMotionProps, motion } from 'motion/react'
import { type ReactNode } from 'react'
import ClickWrapper from '../ClickWrapper'
import styles from './SidebarTab.module.css'

export interface SidebarTabProps extends Omit<HTMLMotionProps<'div'>, 'title'> {
	renderIcon?: () => ReactNode
	title: string
	isActive?: boolean
}

// 处理活动状态背景的子组件
function ActiveBackground() {
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			className={styles.activeBackground}
		/>
	)
}

export default function SidebarTab({
	id,
	title,
	isActive = false,
	renderIcon,
	className,
	...props
}: SidebarTabProps) {
	return (
		<ClickWrapper
			whileTap={{ scale: 0.98 }}
			className={clsx(styles.tab, isActive && styles.tabActive, className)}
			title={title}
			{...props}
		>
			<AnimatePresence>{isActive && <ActiveBackground />}</AnimatePresence>
			{renderIcon?.()}
		</ClickWrapper>
	)
}
